import { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faEdit,
  faEye,
  faPen,
  faCircleChevronRight,
  faCircleChevronLeft,
  faFilter,
  faUndo,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { departments } from "../../utils/enoms";
import { getAdminUsers } from "../../redux/actions/admins";
import { authanticatedUser, formatTime } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";

function AdminUsersTable({ options }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { admins, loading } = useSelector((state) => state.admins);
  const [department, setDepartment] = useState('');
  const [position, setPosition] = useState('');
  const [name, setName] = useState('');
  const itemsPerPage = 50;

  const editAdminUser = (adminData) => {
    navigate(`/admin/edit/:id`, adminData)
    console.log(adminData)
  }


  useEffect(() => {
    dispatch(getAdminUsers({token: authanticatedUser.token}));
  }, []);


  const allAdmins = admins?.filter(ad => department ? ad.role.toLowerCase() === department.toLowerCase() : ad && ad.name.toLowerCase().startsWith(name.toLowerCase()) && ad.position.toLowerCase().startsWith(position.toLowerCase()));

  const toggleEditAdmin = (data) => {

    toggleEditAdminUserModal(data)
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = allAdmins?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(allAdmins?.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  

  const getPageNumbers = () => {
    let startPage = Math.max(1, currentPage - 4);
    let endPage = Math.min(totalPages, startPage + 9);

    if (endPage - startPage < 9) {
      startPage = Math.max(1, endPage - 9);
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };
  const { toggleCreateAdminUserModal, toggleEditAdminUserModal } = options;



  return (
    <div className="flex flex-wrap -mx-3">
      <div className="mt-10 mb-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mx-3 px-3 py-10 w-full bg-white border-0 border-transparent border-solid shadow-soft-xl rounded-2xl bg-clip-border">
        <div className="sm:col-span-2 mb-2">
          <label
            htmlFor="fullName"
            className="block text-xl font-bold text-primary-dark"
          >
            Full Name
          </label>
          <div className="mt-2">
            <input
              id="fullName"
              name="fullName"
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              className="block w-full pl-5 py-3 rounded-md border-0 text-primary shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="sm:col-span-1 mb-2">
          <label
            htmlFor="mobileNumber"
            className="block text-xl font-bold text-primary-dark"
          >
            Department
          </label>
          <div className="mt-2">
          <select id="department" onChange={e => setDepartment(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option value={''}>All Department</option>
                  {departments?.map((dept, i) =>
                    <option value={dept.role} key={i}>{dept?.name}</option> 
                  )}
                </select>
          </div>
        </div>
        <div className="sm:col-span-1 mb-2">
          <label
            htmlFor="position"
            className="block text-xl font-bold text-primary-dark"
          >
            Position
          </label>
          <div className="mt-2">
            <input
              id="position"
              name="position"
              type="text"
              value={position}
              onChange={e => setPosition(e.target.value)}
              className="block w-full pl-5 py-3 rounded-md border-0 text-primary shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div className="sm:col-span-2 md:col-span-2">
          <div className="w-full">
            {/* <Datepicker
              value={{ startDate: filters.startDate, endDate: filters.endDate }}
              onChange={handleDateChange}
              inputClassName="pl-5 py-3.5 w-full rounded-md border-0 py-1.5 text-primary shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
              containerClassName="relative z-2"
              popoverDirection="down"
            /> */}
          </div>
        </div>

        <div className="sm:col-span-2 md:col-span-1 flex flex-col sm:flex-row justify-center md:justify-end items-center gap-2">
 
        </div>
        <div className="sm:col-span-2 md:col-span-1 flex justify-center md:justify-end">
          {authanticatedUser?.role?.toLowerCase() === 'iso' ? '' : (
          <button
            type="button"
            className="w-full sm:w-auto px-6 py-3 font-bold text-center bg-gradient-to-tl from-brand-5 to-primary uppercase align-middle transition-all rounded-lg cursor-pointer text-sm ease-soft-in tracking-tight-soft shadow-soft-md bg-150 bg-x-25 hover:scale-102 active:opacity-85 hover:shadow-soft-xs text-white"
            onClick={() => toggleCreateAdminUserModal()}
          >
            <FontAwesomeIcon
              icon={faUserPlus}
              className="mr-2"
              style={{ fontSize: "20px" }}
            />
            Create Admin User
          </button>
          )
          }
        </div>
      </div>

      <div className="flex-none w-full max-w-full px-3">
        <div className="relative flex flex-col min-w-0 mb-6 break-words bg-white border-0 border-transparent border-solid shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="p-6 pb-0 mb-6 bg-white text-primary text-4xl  font-extrabold border-b-0 border-b-solid rounded-t-2xl border-b-transparent">
            <h1>Administrative Users</h1>
          </div>
          <div className="flex-auto px-0 pt-0 pb-2">
            <div className="p-0 overflow-x-auto">
              <div className="inline-block min-w-full align-middle">
                <div className="overflow-hidden shadow-soft-xl ">
                  <div className="max-h-[calc(10*3rem)] overflow-y-auto">
                    <table className="items-center min-w-full table-auto border-gray-200 text-slate-500">
                      <thead className="sticky top-0 z-10 bg-brand-2">
                        <tr>
                          <th className="px-6 py-3 font-bold text-left uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base  border-b-solid tracking-none whitespace-nowrap text-white ">
                            Name
                          </th>
                          <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base  border-b-solid tracking-none whitespace-nowrap text-white ">
                            Department
                          </th>
                          <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base  border-b-solid tracking-none whitespace-nowrap text-white ">
                            Position
                          </th>
                          <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base  border-b-solid tracking-none whitespace-nowrap text-white ">
                            Branch
                          </th>
                          <th className="px-6 py-3 font-bold text-center uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base  border-b-solid tracking-none whitespace-nowrap text-white ">
                            Status
                          </th>
                          <th className="px-6 py-3 font-bold text-center uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base  border-b-solid tracking-none whitespace-nowrap text-white ">
                            Created
                          </th>
                          <th className="px-6 py-3 font-bold text-center uppercase align-middle bg-transparent border-b border-gray-200 shadow-none text-base  border-b-solid tracking-none whitespace-nowrap text-white ">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems?.map((admin, i) => (
                          <tr key={i}>
                            <td className="p-2 align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                              <div className="flex px-2 py-1">
                                <div className="flex-shrink-0 w-9 h-9">
                                  {/* <img
                                    src={admin?.image}
                                    className="w-full h-full rounded-xl object-cover"
                                    alt={admin?.name}
                                  /> */}
                                </div>
                                <div className="flex flex-col justify-center ml-4">
                                  <h6 className="mb-0 text-sm font-semibold text-primary">
                                    {admin?.name}
                                  </h6>
                                  <p className="mb-0 text-xs text-brand-1">
                                    {admin?.email}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td className="p-2 align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                              <p className="mb-0 text-sm font-semibold text-primary">
                                {admin?.role}
                              </p>
                            </td>
                            <td className="p-2 align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                              <p className="mb-0 text-sm font-semibold text-primary">
                                {admin?.position}
                              </p>
                            </td>
                            <td className="p-2 align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                              <p className="mb-0 text-sm font-semibold text-primary">
                                {admin?.branch}
                              </p>
                            </td>
                            <td className="p-2 text-sm text-center align-middle bg-transparent border-b whitespace-nowrap shadow-transparent">
                              <span
                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded ${
                                  admin?.status === "active"
                                    ? "bg-green-100 text-green-800"
                                    : "bg-red-100 text-red-800"
                                }`}
                              >
                                {admin?.status}
                              </span>
                            </td>
                            <td className="p-2 text-center align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                              <span className="text-sm font-semibold text-brand-1">
                                {formatTime(admin?.createdAt)}
                              </span>
                            </td>
                            <td className="p-2 text-center align-middle bg-transparent border-b border-gray-300 whitespace-nowrap shadow-transparent">
                              <div className="flex justify-center space-x-2">
                                {/* <button
                                  className="inline-flex items-center px-3 py-1 bg-brand-6 hover:bg-brand-7 text-white text-sm font-semibold rounded"
                                  onClick={() => navigate(`/profile`)}
                                >
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    className="mr-1"
                                  />
                                  View
                                </button> */}
                              </div>
                              {authanticatedUser?.role?.toLowerCase() === 'iso' ? '' :
                                <div className="flex justify-center space-x-2">
                                  <button
                                    className="inline-flex items-center px-3 py-1 bg-red-500 hover:bg-red-500 text-white text-sm font-semibold rounded"
                                    onClick={() => toggleEditAdmin(admin) }
                                    disabled={authanticatedUser._id === admin._id ? true : false}
                                  >
                                    <FontAwesomeIcon
                                      icon={faPen}
                                      className="mr-1"
                                    />
                                    Edit
                                  </button>
                                </div>
                              }

                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full mt-4">
        <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-white rounded-lg shadow">
          <div className="text-sm font-semibold text-primary mb-2 sm:mb-0">
            Showing {indexOfFirstItem + 1} to{" "}
            {Math.min(indexOfLastItem, admins?.length)} of{" "}
            {admins?.length} results
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className={`rounded-md p-1 ${
                currentPage === 1
                  ? "text-gray-300 cursor-not-allowed"
                  : "text-primary hover:bg-gray-100"
              }`}
            >
              <FontAwesomeIcon icon={faCircleChevronLeft} className="text-xl" />
            </button>
            <div className="flex space-x-1">
              {getPageNumbers().map((number) => (
                <button
                  key={number}
                  onClick={() => paginate(number)}
                  className={`px-3 py-1 rounded-md text-sm ${
                    currentPage === number
                      ? "bg-primary text-white"
                      : "bg-gray-200 text-primary hover:bg-gray-300"
                  }`}
                >
                  {number}
                </button>
              ))}
            </div>
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`rounded-md p-1 ${
                currentPage === totalPages
                  ? "text-gray-300 cursor-not-allowed"
                  : "text-primary hover:bg-gray-100"
              }`}
            >
              <FontAwesomeIcon
                icon={faCircleChevronRight}
                className="text-xl"
              />
            </button>
          </div>
        </div>
        
      </div>
        </div>
      </div>
    </div>
  );
}

export default AdminUsersTable;
